import styles from "../landing-page-four.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { usePaths } from "BEDROCK/paths";

interface HeaderSectionProps {
  onClickStart: () => void;
}

export const HeaderSection = (props: HeaderSectionProps) => {
  return (
    <div className={styles.headerSectionContainer}>
      <div className={styles.headerTitles}>
        <h1 className={styles.headerSectionTitle}>Custom Trail Art </h1>
        <h2 className={styles.headerSectionSubtitle}>
          Custom art prints from your walks, runs, hikes, and rides
        </h2>
      </div>
      <CTAButton title="BROWSE" onClick={props.onClickStart} />
    </div>
  );
};
